/**
 * Small UPS Requirements — labels, placeholders, and dropdown options.
 * Workbook: Type of UPS = 1P / 3P; Input Power Phase = phases dropdown; mounting 2-post / 4-post.
 */
export const SMALL_UPS_TYPE_OPTIONS = ['1P', '3P'] as const;

export const SMALL_UPS_INPUT_PHASE_OPTIONS = ['1P', '3P'] as const;

/** Matches server {@link SMALL_UPS_MOUNTING_OPTIONS} in `server/utils/requestValidation.ts`. */
export const SMALL_UPS_MOUNTING_OPTIONS = ['2-post', '4-post'] as const;

/** Mount Type — additive vs 2-post/4-post Mounting (#714). */
export const SMALL_UPS_MOUNT_TYPE_OPTIONS = ['Wall', 'Floor', 'Rack'] as const;

export const SMALL_UPS_PLACEHOLDERS = {
  manufacturer: 'Enter equipment manufacturer name',
  model: 'Enter equipment model number',
  description: '',
  serialNumber: 'Enter equipment serial number',
  upsType: 'Select 1P or 3P',
  inputVoltage: 'Enter input voltage configuration',
  inputPlug: 'Specify input plug type',
  inputPowerPhase: 'Select input phase',
  upsCapacity: 'Enter UPS capacity',
  loadPercentage: 'Enter current load percentage',
  runtime: 'Enter required battery runtime in minutes',
  batteryCabinetQty: 'Enter quantity of battery cabinets',
  mounting: 'Select 2-post or 4-post',
  mountType: 'Select Wall, Floor, or Rack',
  outlets: 'Specify controllable and always-on outlet quantities',
  expectedLoadGrowth: 'Enter expected load growth',
  requiredSensors: 'Enter required sensors',
  notes: 'Enter any additional Small UPS requirements or notes',
} as const;
